<script setup>
import { ref, computed, onMounted } from 'vue'

const isStandalone = ref(true)

onMounted(() => {
  /*if(window.innerWidth > 768) {
    isStandalone.value = true;
  } else {
    // Esto detecta si la app ya está instalada y corriendo como PWA
    isStandalone.value = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone || (window.matchMedia('(display-mode: fullscreen)').matches)
  }*/
})
</script>

<template>
  <div v-if="!isStandalone" class="w-full h-screen bg-zinc-100 dark:bg-zinc-800">
    <div class="flex items-center justify-center h-screen bg-zinc-100 dark:bg-zinc-800 p-4">
      <div class="text-center max-w-md bg-white dark:bg-zinc-900 rounded-xl shadow-md p-6">
        <img src="img/app-icons/android-chrome-192x192.png" class="mx-auto"/>
        <p class="text-3xl font-bold text-[#FF7043] mb-6">
          ¡Instala nuestra app!
        </p>
        <p class="text-lg mb-6 text-zinc-700 dark:text-zinc-200">
          Para acceder a nuestro menú digital y disfrutar de una mejor experiencia, instala la aplicación en tu móvil:
        </p>
        <ul class="text-left text-zinc-700 dark:text-zinc-200 list-disc list-inside mb-6 space-y-1">
          <li><strong>Android:</strong> toca el menú del navegador y selecciona <em>“Agregar a pantalla de inicio”</em>.</li>
          <li><strong>iOS (iPhone/iPad):</strong> toca el icono de <em>Compartir</em> en Safari y selecciona <em>“Añadir a pantalla de inicio”</em>.</li>
        </ul>
        <p class="text-zinc-500 dark:text-zinc-400 text-sm">
          Así tendrás acceso directo y nuestra app se comportará como una aplicación nativa.
        </p>
      </div>
    </div>
  </div>
  <router-view v-else/>
</template>
